import type { ThemeConfig } from "../../types";

export const pastelTheme: ThemeConfig = {
  weak: { color: "#fecaca", label: "Weak" },
  fair: { color: "#fed7aa", label: "Fair" },
  good: { color: "#bfdbfe", label: "Good" },
  strong: { color: "#bbf7d0", label: "Strong" },
};
